module.exports = __webpack_public_path__ + "img/tutorial_blue.d277e6dd.png";